(() => {
  class MailorderPharmacyController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        isMailorderOnly: $scope.ngDialogData.isMailorderOnly,
        mailorderPharmacy: $scope.ngDialogData.mailorderPharmacy,
        medication: $scope.ngDialogData.medication,
        visitState: $scope.ngDialogData.visitState
      });
    }

    close() {
      this.$scope.closeThisDialog(null);
    }

    confirm() {
      var response = {
        mailorder: true
      };
      this.$scope.closeThisDialog(response);
    }

    search() {
      var response = {
        mailorder: false
      };
      this.$scope.closeThisDialog(response);
    }

  }

  MailorderPharmacyController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('MailorderPharmacyController', MailorderPharmacyController);
})();